import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getPlantLevelConfigByIdSlice = createApi(`GetPlantLevelConfigByIdSlice`,"GET");

const GetPlantLevelConfigByIdSlice = createSlice({
  name: 'GetPlantLevelConfigByIdSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPlantLevelConfigByIdSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPlantLevelConfigByIdSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getPlantLevelConfigByIdSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetPlantLevelConfigByIdSlice.reducer;